import { render } from "./TravelAgents.vue?vue&type=template&id=b8dc92c0&scoped=true"
import script from "./TravelAgents.vue?vue&type=script&lang=js"
export * from "./TravelAgents.vue?vue&type=script&lang=js"

import "./TravelAgents.vue?vue&type=style&index=0&id=b8dc92c0&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/Israr/vue/matrixlimos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8dc92c0"]])

export default __exports__